import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import React from 'react';
import AppHeader from '../../../components/Header/Header';
import AppFooter from '../../../components/Footer/footer';
import BannerSection from '../../../components/ui/BannerSection';
import SectionHeading from '../../../components/SectionHeading';


function Unidade_organica() {
  const blogData = [
  {
    id: 1,
    image: require('../../../assets/UN_OR_04.jpg'),
    title: 'Engenharia',
    description: 'Desenvolva o futuro construindo o presente! Descubra como o curso de Engenharia Civil pode abrir portas para uma carreira emocionante e impactante.',
    link: '#'
  },
  {
    id: 2,
    image: require('../../../assets/UN_OR_02.jpg'),
    title: 'Ciência da Gestão',
    description: 'Desbloqueie seu potencial de liderança com o curso de Ciência da Gestão! Descubra como dominar habilidades estratégicas, liderança e análise de dados para impulsionar sua carreira.',
    link: '#'
  },
  {
    id: 3,
    image: require('../../../assets/UN_OR_01.jpg'),
    title: 'Ciência da Saúde',
    description: 'Nosso curso de Ciências Sociais oferece uma perspectiva única e abrangente sobre questões que moldam o mundo em que vivemos.',
    link: '/programas/unidade-organica/ciencia-saude'
  },
  {
    id: 3,
    image: require('../../../assets/UN_OR_03.jpg'),
    title: 'Ciências Socais',
    description: 'Nosso curso de Ciências Sociais oferece uma visão aprofundada das estruturas, dinâmicas e desafios que moldam nossa sociedade. ',
    link: '/programas/unidade-organica/ciencias-sociais'
  }
]
    return (
      <>
        <div className="App" style={{ background: "#f8f9fa" }}>
          <header id="header">
            <AppHeader />
          </header>
          <BannerSection
            title="Unidade Orgânica"
            subtitle="Bem-vindo à unidade orgânica do Instituto Superior Politécnico Atlântida"
            description="Aqui você encontrará informações sobre a estrutura organizacional e as funções da unidade orgânica, responsável pela gestão acadêmica e administrativa do ISP-Atlântida."
            backgroundImage={require('../../../assets/BannerANU_ispa.jpg')}
            backgroundId="instituition-Banner"
          />
          <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
            <br />
        <div className="row flex-row-reverse">
            <div className="col-12 col-md-8 col-lg-9 col-xl-9 col-xxl-9">
            <br />
            <div className="details-magazine">
             
                <p className="f-reg" style={{ fontSize: '1.2rem'}}>
                   <SectionHeading title=" Unidade Organica" />
                    A Unidade Orgânica é a estrutura responsável pela gestão acadêmica e administrativa do Instituto Superior Politécnico Atlântida, garantindo a qualidade do ensino e a implementação das políticas institucionais.
                </p>
                <br />
            </div>
            </div>
        </div>
           <section id="blog" className="blog-section py-5 bg-light">
      <Container fluid="lg">
            <Row className="g-4">
              {blogData.map((blog) => (
                <Col xs={12} sm={6} md={4} lg={3} key={blog.id}>
                  <Card className="blog-card h-100 shadow-sm border-0 rounded-4 overflow-hidden">
                    <div className="image-container">
                      <Card.Img
                        variant="top"
                        src={blog.image}
                        className="object-fit-cover"
                        style={{ height: "200px", width: "100%" }}
                      />
                    </div>
                    <Card.Body className="d-flex flex-column">
                      <Card.Title className="fw-semibold mb-2">{blog.title}</Card.Title>
                      <Card.Text className="text-muted small flex-grow-1">
                        {blog.description}
                      </Card.Text>
                      <a
                        href={blog.link}
                        rel="noopener noreferrer"
                        className="btn btn-outline-success mt-3 d-inline-flex align-items-center justify-content-between gap-2"
                        style={{ transition: "all 0.3s ease" }}
                      >
                        Leia mais <i className="fas fa-chevron-right"></i>
                      </a>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
           <style>{`
  .blog-section .blog-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .blog-section .blog-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
  }

  .section-title {
    font-size: 2rem;
  }

  .section-subtitle {
    font-size: 1rem;
    max-width: 600px;
    margin: 0 auto;
  }

  .btn-outline-success:hover {
    background-color: #28a745;
    color: white;
  }

  .image-container {
    overflow: hidden;
  }

  .image-container img {
    transition: transform 0.4s ease;
  }

  .blog-card:hover .image-container img {
    transform: scale(1.08);
  }

  /* Margem aplicada apenas em telas grandes */
  @media (min-width: 992px) {
    .blog-section {
      margin-left: -68px;
    }
  }

  /* Remove a margem lateral em dispositivos pequenos */
  @media (max-width: 991.98px) {
    .blog-section {
      margin-left: 0;
    }
  }
`}</style>

          </Container>
        </section>
        </main>
        <footer id="footer">
        <AppFooter />
      </footer>
        </div>
    </>
     )
}

export default Unidade_organica;